import useDebounced from 'hooks/useDebounce';
import studyQueries from 'hooks/studies/studyQueries';
import { SearchCriteria } from 'pages/Study/Study.types';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

const useGetDebouncedBaseStudiesFlat = (searchCriteria: Partial<SearchCriteria>, enabled?: boolean) => {
    const stableArgs = useMemo(() => searchCriteria, [searchCriteria]);
    const debouncedSearchCriteria = useDebounced(stableArgs, 300);

    const query = studyQueries.baseStudies.debouncedSearchFlat(debouncedSearchCriteria);

    return useQuery({
        ...query,
        enabled,
        refetchOnWindowFocus: false,
    });
};

export default useGetDebouncedBaseStudiesFlat;
